import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Swatchbook = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M434.66 167.71 344.5 77.36a31.83 31.83 0 0 0-45-.07l-.07.07L224 152.88V424l210.66-211.1a32 32 0 0 0 0-45.19zM480 320H373.09L186.68 506.51c-2.06 2.07-4.5 3.58-6.68 5.49h300a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32zM192 32a32 32 0 0 0-32-32H32A32 32 0 0 0 0 32v384a96 96 0 0 0 192 0zM96 440a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm32-184H64v-64h64zm0-128H64V64h64z"
  }));
});
Swatchbook.displayName = 'Swatchbook';
export var SwatchbookDimensions = {
  height: 512,
  width: 512
};